export var SENTRY_RELEASE = "0bfa6dca65b798c5b19a2096e33b25d1513ea776";
